import React from 'react';

import PropTypes from 'prop-types';

class MenuIcon extends React.Component {
  render() {
    const { unreadCount, onClick } = this.props;
    return (
      <span className="notification-dropdown__menu-icon" aria-haspopup="true" aria-expanded="false" data-mount="menu-icon" data-toggle="dropdown" onClick={onClick}>
        <i className="material-icons" data-attribute="bell-icon">notifications</i>
        <span className="badge" data-attribute="badge">
          {unreadCount > 0 ? unreadCount : ""}
        </span>
      </span>
    );
  }
}

MenuIcon.propTypes = {
  unreadCount: PropTypes.number.isRequired,
  onClick: PropTypes.func
};

export default MenuIcon;
